const NHL_HEADER_HEIGHT = 64;
const WEB_VIEW_HEIGHT = 0;
export const HEADER_HEIGHT = window.location.search.includes('wv=true') ? WEB_VIEW_HEIGHT : NHL_HEADER_HEIGHT;
